import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validateCadastrar from "./form-validate-cadastrar";
import validateEditar from "./form-validate-editar";

const CategoriaCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    nome: "",
    nome_in: "",
    nome_es: "",
    imagem: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-categoria").valid()) {
      return;
    }

    try {
      const formData = new FormData();

      formData.append("id", state.id);
      formData.append("nome", state.nome);
      formData.append("nome_in", state.nome_in);
      formData.append("nome_es", state.nome_es);
      formData.append("imagem", state.imagem);

      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/categoria", formData);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/categoria");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a categoria.");
    }
  };

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(`/categoria/${location.state.id}`);

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        setState(data.data);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da categoria");
      }
    };

    let validacao = window
      .$("#form-categoria")
      .validate(!location.state ? validateCadastrar : validateEditar);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Categorias"
        header="Cadastro da Categoria"
        action={{ titulo: "Voltar", link: "/categoria" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da categoria</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-categoria">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Imagem da categoria</label>
                            <input
                              type="file"
                              placeholder="Imagem da categoria"
                              className="form-control"
                              name="imagem"
                              accept="image/*"
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  imagem: e.target.files[0],
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome da categoria</label>
                                          <input
                                            type="text"
                                            placeholder="Nome da categoria"
                                            className="form-control"
                                            name="nome"
                                            value={state.nome}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome da categoria</label>
                                          <input
                                            type="text"
                                            placeholder="Nome da categoria"
                                            className="form-control"
                                            name="nome_in"
                                            value={state.nome_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome da categoria</label>
                                          <input
                                            type="text"
                                            placeholder="Nome da categoria"
                                            className="form-control"
                                            name="nome_es"
                                            value={state.nome_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CategoriaCadastrar;
